import { render, staticRenderFns } from "./RoutedBlock.vue?vue&type=template&id=32938ef2&"
import script from "./RoutedBlock.vue?vue&type=script&lang=js&"
export * from "./RoutedBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports